// extracted by mini-css-extract-plugin
export default {"filterArrow":"FilterWindow_filterArrow__+89X1","placeHolderShimmer":"FilterWindow_placeHolderShimmer__ScJf4"};